import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { AMROUTES, HROUTES } from './navigation-routes.config';
import { LayoutService } from '../services/layout.service';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss']
})
export class HorizontalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  public menuItems: any[];
  public config: any = {};
  level: number = 0;
  transparentBGClass = "";
  menuPosition = 'Side';

  layoutSub: Subscription;
  user_role: any
  constructor(private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private router: Router) {
    this.user_role = JSON.parse(localStorage.getItem('user'))
    this.config = this.configService.templateConf;
  }

  ngOnInit() {
    if (this.user_role.roles === 'superadmin') {
      this.menuItems = this.filterRoutesACCORDINGTOSERVERTYPE();
    }
    if (this.user_role.roles === 'admin' || this.user_role.roles === 'mturkers') {
      this.menuItems = AMROUTES;

    }

  }
  filterRoutesACCORDINGTOSERVERTYPE() {
    // Commented out environment-specific filtering - now returns all routes
    // switch (environment.name) {
    //   case 'do':
    //     return HROUTES.filter((item) => item.title !== 'Data' && item.title !== 'Prompt');
    //   case 'production':
    //     return HROUTES.filter((item) => item.title !== 'Utility');
    //   case 'qc':
    //     // return HROUTES.filter((item)=>item.title !== 'Data' && item.title !== 'Prompt');  
    //     return HROUTES.filter((item) => item.title !== 'Prompt');
    //   default:
    //     return HROUTES;
    // }
    // Return all routes regardless of environment
    return HROUTES;
  }

  ngAfterViewInit() {

    this.layoutSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    })
  }

  loadLayout() {

    if (this.config.layout.menuPosition && this.config.layout.menuPosition.toString().trim() != "") {
      this.menuPosition = this.config.layout.menuPosition;
    }


    if (this.config.layout.variant === "Transparent") {
      this.transparentBGClass = this.config.layout.sidebar.backgroundColor;
    }
    else {
      this.transparentBGClass = "";
    }

  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }

}
